/* global femcare */

femcare.navigation.anchor = {

    /**
     * Initialize anchor navigation
     */
    init() {
        const $selectAnchor = $('.sticky-anchor--select');
        const $listAnchor = $('.sticky-anchor--list');
        this.anchoredSections = $('[data-anchor-index]').toArray();

        if ($selectAnchor.length && this.anchoredSections.length) {
            this.removeNavigationItemsWithoutSections($selectAnchor);
            femcare.shared.customDropdown.create($selectAnchor[0]);
            $selectAnchor.append('<div class="sticky-anchor__underline"></div>');
            this.initAnchor($selectAnchor, ($anchor, $activeOption) => {
                femcare.shared.customDropdown.setOption($activeOption[0]);
            });
        }

        if ($listAnchor.length && this.anchoredSections.length) {
            this.removeNavigationItemsWithoutSections($listAnchor);
            const activeListItemClass = 'active';
            this.initAnchor($listAnchor, ($anchor, $activeOption) => {
                $anchor.find('[data-value]')
                    .removeClass(activeListItemClass)
                    .removeAttr('aria-current');

                $activeOption
                    .addClass(activeListItemClass)
                    .attr('aria-current', 'true');
            });
        }
    },

    /**
     * Remove CMS navigation items which do not have a corresponding page section.
     * @param {jQuery} $anchor - The anchor element
     */
    removeNavigationItemsWithoutSections($anchor) {
        const availableSectionIndexes = this.anchoredSections.map((section) =>
            section.getAttribute('data-anchor-index')
        );

        $anchor.find('[data-value], option[value]').toArray().forEach((navigationItem) => {
            const targetSectionIndex = navigationItem.getAttribute('data-value') || navigationItem.value;

            if (!availableSectionIndexes.includes(targetSectionIndex)) {
                navigationItem.remove();
            }
        });
    },

    /**
     * Initialize individual anchor
     * @param {jQuery} $anchor - The anchor element
     * @param {Function} setActive - Function to set the active state of the anchor
     */
    initAnchor($anchor, setActive) {
        const linkedSections = this.anchoredSections.filter((section) => {
            const sectionIndex = section.getAttribute('data-anchor-index');
            return $anchor.find(`[data-value=${sectionIndex}]`).length;
        });
        let activeSectionIndex = null;
        let updateScheduled = false;

        const updateAnchor = () => {
            updateScheduled = false;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            let mostVisibleLinkedSection = null;
            let largestVisibleSectionHeight = 0;

            linkedSections.forEach((section) => {
                const sectionBounds = section.getBoundingClientRect();
                const visibleSectionHeight = Math.max(0,
                    Math.min(sectionBounds.bottom, viewportHeight) - Math.max(sectionBounds.top, 0)
                );

                if (visibleSectionHeight > largestVisibleSectionHeight) {
                    largestVisibleSectionHeight = visibleSectionHeight;
                    mostVisibleLinkedSection = section;
                }
            });

            const hasVisibleLinkedSection = Boolean(mostVisibleLinkedSection);
            $anchor
                .toggleClass('sticky-anchor--hidden', !hasVisibleLinkedSection)
                .attr('aria-hidden', String(!hasVisibleLinkedSection));

            if (!hasVisibleLinkedSection) {
                return;
            }

            const visibleSectionIndex = mostVisibleLinkedSection.getAttribute('data-anchor-index');
            if (visibleSectionIndex === activeSectionIndex) {
                return;
            }

            const $activeNavigationItem = $anchor.find(`[data-value=${visibleSectionIndex}]`);
            if ($activeNavigationItem.length) {
                activeSectionIndex = visibleSectionIndex;
                setActive($anchor, $activeNavigationItem);
                $anchor.find('.select-selected').click();
            }
        };

        const requestUpdate = () => {
            if (!updateScheduled) {
                updateScheduled = true;
                window.requestAnimationFrame(updateAnchor);
            }
        };

        $(window).on('scroll resize', requestUpdate);
        requestUpdate();

        const animationDuration = 1000;
        $anchor.find('[data-value]').on('click', (e) => {
            e.preventDefault();
            const $target = $(`[data-anchor-index=${e.currentTarget.getAttribute('data-value')}]`);
            if(!$target.length) {
                return;
            }
            const position = $target.position();
            const offset = parseInt($anchor.css('top'), 10) + parseInt($anchor.css('height'), 10);
            const targetY = position.top - offset;

            $('html, body').animate({ scrollTop: targetY }, animationDuration);

            $target.attr('tabindex', '-1');
            $target.trigger('focus');
        });
    }
};
